export const regionaisKeys = {
  regionais: ['regionais'] as const,
  listas: () => [...regionaisKeys.regionais, 'listas'] as const,
}
